import pikachu from "../images/pikachu.png";
import staryu from "../images/staryu.png";
import squirtle from "../images/squirtle.png";
import vileplume from "../images/vileplume.png";
import berry from "../images/berry.png";
import ball from "../images/ball.png";
import seven from "../images/seven.png";

import credit from "../images/credit.png";
import payout from "../images/payout.png";

import one from "../images/one.png";
import two from "../images/two.png";
import three from "../images/three.png";
import gem from "../images/gem.png";
import hand from "../images/hand.png";

const icons = [
    {name: "pikachu", url: pikachu },
    {name: "staryu", url: staryu },
    {name: "squirtle", url: squirtle },
    {name: "berry", url: berry },
    {name: "ball", url: ball },
    {name: "seven", url: seven }
]; 

export { vileplume, credit, payout, one, two, three, gem, hand };

export default icons;